import { gql } from '__generated__';

export const AUTH_SESSION = gql(/* GraphQL */ `
  fragment AuthSession on TokenResponse {
    caslAbilities
    user {
      id
      firstName
      lastName
      email
      phoneNumber
      cognitoUsername
      isActive
      emailNotifications
      mobilePushNotifications
      timezone
      timezoneDisplayPreference
      tenant {
        id
        name
        timezone
        dateFormat
      }
      userGroups {
        id
        name
        cognitoGroupName
        displayColour
      }
      tags {
        id
        name
        displayColour
        archived
      }
      brands {
        id
        name
        archived
      }
    }
    tokens {
      id_token
      access_token
      refresh_token
      expires_at
      token_type
    }
  }
`);
